import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "paste-field" }
const _hoisted_2 = ["data-placeholder"]
const _hoisted_3 = {
  key: 0,
  class: "paste-status"
}
const _hoisted_4 = {
  key: 1,
  class: "paste-status is-error"
}

import { onMounted, ref } from 'vue';
import { loadBoardImage, splitBoardBody } from '@/utils/boardBody';
import { boardImageApi } from '@/services/api';


export default /*@__PURE__*/_defineComponent({
  __name: 'PasteImageField',
  props: {
    modelValue: {},
    placeholder: { default: '내용을 입력하세요. 사진은 붙여넣기 하면 들어갑니다.' }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const editorRef = ref<HTMLElement | null>(null);
const uploading = ref(false);
const errorText = ref('');

const appendText = (parent: HTMLElement, text: string) => {
  const lines = text.split('\n');
  lines.forEach((line, index) => {
    if (line) parent.appendChild(document.createTextNode(line));
    if (index < lines.length - 1) parent.appendChild(document.createElement('br'));
  });
};

const paint = async (value: string) => {
  const editor = editorRef.value;
  if (!editor) return;
  editor.innerHTML = '';
  for (const part of splitBoardBody(value)) {
    if (part.kind === 'text') {
      appendText(editor, part.text);
      continue;
    }
    const img = document.createElement('img');
    img.className = 'paste-image';
    img.alt = '';
    img.dataset.file = part.file;
    try {
      img.src = await loadBoardImage(part.file);
    } catch (error) {
      img.alt = '사진을 불러오지 못했습니다';
    }
    editor.appendChild(img);
  }
};

const serializeNode = (node: Node): string => {
  if (node.nodeType === Node.TEXT_NODE) return node.textContent || '';
  if (!(node instanceof HTMLElement)) return '';
  const file = node.dataset.file;
  if (file) return `{{img:${file}}}`;
  if (node.tagName === 'BR') return '\n';
  const inner = [...node.childNodes].map(serializeNode).join('');
  if (node.tagName === 'DIV' || node.tagName === 'P') {
    return `\n${inner}`;
  }
  return inner;
};

const sync = () => {
  const editor = editorRef.value;
  if (!editor) return;
  const value = [...editor.childNodes].map(serializeNode).join('').replace(/^\n/, '').trim();
  emit('update:modelValue', value);
};

const placeNode = (node: Node) => {
  const editor = editorRef.value;
  if (!editor) return;
  const sel = window.getSelection();
  if (!sel || !sel.rangeCount || !editor.contains(sel.anchorNode)) {
    editor.appendChild(node);
    return;
  }
  const range = sel.getRangeAt(0);
  range.deleteContents();
  range.insertNode(node);
  range.setStartAfter(node);
  range.collapse(true);
  sel.removeAllRanges();
  sel.addRange(range);
};

const onPaste = async (event: ClipboardEvent) => {
  const imageItem = [...(event.clipboardData?.items || [])].find((item) => item.type.startsWith('image/'));
  event.preventDefault();
  errorText.value = '';
  if (imageItem) {
    const file = imageItem.getAsFile();
    if (!file) return;
    const current = editorRef.value?.querySelectorAll('img').length || 0;
    if (current >= 8) {
      errorText.value = '사진은 8장까지 넣을 수 있습니다.';
      return;
    }
    uploading.value = true;
    try {
      const res = await boardImageApi.upload(file);
      const name = res.data?.data?.file;
      if (!name) throw new Error('empty');
      const img = document.createElement('img');
      img.className = 'paste-image';
      img.alt = '';
      img.dataset.file = name;
      img.src = URL.createObjectURL(file);
      placeNode(img);
      sync();
    } catch (error: any) {
      errorText.value = error?.response?.data?.message || '사진을 올리지 못했습니다.';
    } finally {
      uploading.value = false;
    }
    return;
  }
  const text = event.clipboardData?.getData('text/plain') || '';
  if (!text) return;
  placeNode(document.createTextNode(text));
  sync();
};

onMounted(() => {
  paint(props.modelValue || '');
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      ref_key: "editorRef",
      ref: editorRef,
      class: "paste-editor",
      contenteditable: "true",
      role: "textbox",
      "aria-multiline": "true",
      "data-placeholder": __props.placeholder,
      onPaste: onPaste,
      onInput: sync
    }, null, 40, _hoisted_2),
    (uploading.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_3, "사진을 넣는 중"))
      : (errorText.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(errorText.value), 1))
        : _createCommentVNode("", true)
  ]))
}
}

})